import { useNavigate } from 'react-router'
import { useEffect } from 'react'
import { Spinner } from '@phosphor-icons/react'
import { useAuthStore } from '@/feature/auth/store/authStore'

export const Root = () => {
  const { session } = useAuthStore()
  const navigate = useNavigate()

  useEffect(() => {
    if (session?.access_token) {
      navigate(`/dashboard`)
    } else {
      navigate(`/auth/login`)
    }
  }, [navigate, session?.access_token])
  return <Spinner className='h-10 w-10 animate-spin' />
}
